let _dispatch = null;
let _logout = null;

export const injectAuth = (dispatch, logoutAction) => {
  _dispatch = dispatch;
  _logout = logoutAction;
};

export const apiFetch = async (url, options = {}) => {
  const response = await fetch(url, options);
  if (response.status === 401 && _dispatch && _logout) {
    _dispatch(_logout());
  }
  return response;
};
